import 'owl.carousel';
import lozad from 'lozad'

/* HOME */
export const initOwlCarouselSectionPromoFull = () => {
    $(".owl-carousel-section-promo-full").owlCarousel({
        loop:true,
        autoplay:true,
        margin:0,
        nav: false,
        dots:true,
        smartSpeed:450,
        autoplaySpeed:2000,
        autoplayTimeout:6000,
        items:1,
        responsive:{
            0:{
                autoWidth:true
            },
            650:{
                autoWidth:false
            }
        }
    });
    $('.owl-carousel-section-promo-full .owl-dots .owl-dot').on('click', function () {
        stopCarouselAutoPlayHome();
    });
    function stopCarouselAutoPlayHome() {
        $('.owl-carousel-section-promo-full').trigger('stop.owl.autoplay');
        var carousel = $('.owl-carousel-section-promo-full').data('owl.carousel');
        carousel.settings.autoplay = false; //don't know if both are necessary
        carousel.options.autoplay = false;
    }
};

/* ZONE PAGE */
export const initOwlCarouselFlatSlide = () => {
    $(".owl-carousel-flatslide").owlCarousel({
        loop:false,
        autoplay:false,
        margin:0,
        nav: true,
        dots:false,
        smartSpeed:450,
        items:1
    });
};
export const initOwlCarouselZone = () => {
    $(".owl-carousel-zone").owlCarousel({
        loop:false,
        autoplay:false,
        margin:0,
        nav: true,
        dots:false,
        smartSpeed:450,
        items:1
    });
};
export const initOwlCarouselZone2 = () => {
    $(".owl-carousel-zone2").owlCarousel({
        loop:false,
        autoplay:false,
        margin:0,
        nav: true,
        dots:false,
        smartSpeed:450,
        items:1
    });
};
export const initOwlCarouselZone3 = () => {
    $(".owl-carousel-zone3").owlCarousel({
        loop:false,
        autoplay:false,
        margin:0,
        nav: true,
        dots:false,
        smartSpeed:450,
        items:1
    });
};
export const initOwlCarouselZoneDoble = () => {
    $(".owl-carousel-zone-doble").owlCarousel({
        loop:false,
        autoplay:false,
        margin:10,
        nav: true,
        dots:false,
        smartSpeed:450,
        responsive:{
            0:{
                items:1
            },
            800:{
                items:2
            }
        }
    });
};
export const initOwlCarouselBarrio = () => {
    $(".owl-carousel-barrio").owlCarousel({
        loop:false,
        autoplay:false,
        margin:40,
        nav: true,
        dots:false,
        smartSpeed:450,
        autoHeight: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            900:{
                items:3
            }
        }
    });
};
export const initOwlCarousel4columns = () => {
    $(".owl-carousel-4columns").owlCarousel({
        loop:false,
        autoplay:false,
        nav: true,
        dots:false,
        smartSpeed:450,
        autoHeight: true,
        responsive:{
            0:{
                items:1,
                margin:0
            },
            600:{
                items:2,
                margin:20
            },
            900:{
                items:3,
                margin:30
            },
            1200:{
                items:4,
                margin:30
            }
        }
    });

};